import { Button } from '../../ui/button';
import { Field, TextArea } from './fields';
import type { DraftExample } from './types';

/** Few-shot pairs: how a good answer sounds, not a template to copy. */
export function ExamplesField({
  examples,
  onChange,
}: {
  examples: DraftExample[];
  onChange: (next: DraftExample[]) => void;
}) {
  const patch = (i: number, part: Partial<DraftExample>) =>
    onChange(examples.map((e, j) => (j === i ? { ...e, ...part } : e)));

  return (
    <fieldset className="space-y-2">
      <legend className="text-xs font-medium text-muted-fg">Примеры «вопрос — ответ»</legend>
      {examples.map((example, i) => (
        <div key={i} className="space-y-1 rounded border border-border p-2">
          <Field label={`Вопрос клиента ${i + 1}`}>
            <TextArea
              aria-label={`Вопрос клиента ${i + 1}`}
              rows={2}
              value={example.question}
              onChange={(e) => patch(i, { question: e.target.value })}
            />
          </Field>
          <Field label={`Ответ агента ${i + 1}`}>
            <TextArea
              aria-label={`Ответ агента ${i + 1}`}
              rows={2}
              value={example.answer}
              onChange={(e) => patch(i, { answer: e.target.value })}
            />
          </Field>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label={`Удалить пример ${i + 1}`}
            onClick={() => onChange(examples.filter((_, j) => j !== i))}
          >
            Удалить пример
          </Button>
        </div>
      ))}
      <Button type="button" variant="secondary" size="sm" onClick={() => onChange([...examples, { question: '', answer: '' }])}>
        + Пример
      </Button>
    </fieldset>
  );
}
